export default {
    default: 'default',
    single: 'single',
    mini: 'mini',
    custom: 'custom'
};
